<script>
import Notification from '../../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  data() {
    return {
      text: '',
      types: '',
      ShowNoti: false,
      gliding: {
        "from": '',
        "takeoffs": '',
        "hours": '',
        "withInstruktor": '',
      },
      isSubmitting: false,
      jadranje: [{
        'nastavitev': '',
        'vrednost': '',
        'polje': '',
        'metoda': '',
        'operator': '',
      }],
      motorna: [{
        'nastavitev': '',
        'vrednost': '',
        'polje': '',
        'metoda': '',
        'operator': '',
      }],
      vrstaNastavitve: '',
    }
  },
  mounted() {
    this.ReadSettings();
  },
  methods: {
    ReadSettings() {
      this.jadranje = [];
      this.motorna = [];
      axios.get('./api/nastavitve/splosno/current/izpis/', {withCredentials: true}).then((response) => {
        this.jadranje = response.data.nastavitve.filter((nastavitev) => nastavitev.vrsta == 'jadralno');
        this.motorna = response.data.nastavitve.filter((nastavitev) => nastavitev.vrsta == 'motorno');
      }).catch((napaka) => {

      });
    },
    getFieldError(input) {
      return null;
    },
    UpdateGliding() {
      this.isSubmitting = true;
      var podatki = new URLSearchParams();
      podatki.append('vrsta', 'jadralno');
      podatki.append('nastavitve', JSON.stringify(this.jadranje));
      axios.post('./api/nastavitve/splosno/current/vnosi/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
        this.isSubmitting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.sporocilo !== undefined) {
          this.text = 'Napaka pri vnosu podatkov. ' + napaka.response.data.sporocilo;
        } else {
          this.text = 'Napaka pri vnosu podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.isSubmitting = false;
      });
    },
    UpdateMotor() {
      this.isSubmitting = true;
      var podatki = new URLSearchParams();
      podatki.append('vrsta', 'motorno');
      podatki.append('nastavitve', JSON.stringify(this.motorna));
      axios.post('./api/nastavitve/splosno/current/vnosi/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
        this.isSubmitting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.sporocilo !== undefined) {
          this.text = 'Napaka pri vnosu podatkov. ' + napaka.response.data.sporocilo;
        } else {
          this.text = 'Napaka pri vnosu podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.isSubmitting = false;
      });
    },
    DodajNastavitevJadro() {
      if (this.jadranje.length <= 15) {
        this.jadranje.push({nastavitev: '', vrednost: ''});
      }

    },
    DodajNastavitevMotorno() {
      if (this.motorna.length <= 15) {
        this.motorna.push({nastavitev: '', vrednost: ''});
      }

    },
    OdstraniNastavitev(index, vrsta) {
      this.vrstaNastavitve = vrsta;
      this.text = 'Ali res želiš izbrisati nastavitev?';
      this.types = 'Vprašanje';
      this.ShowNoti = true;
      this.indexBrisanja = index;
    },
    BrisiNastavitev() {
      if (this.vrstaNastavitve === 'motorno') {
        this.motorna.splice(this.indexBrisanja, 1);
      } else {
        this.jadranje.splice(this.indexBrisanja, 1);
      }

      this.ShowNoti = false;
    },
    CheckOperator(operator) {
      if (!(/^(>=|<=|>|<|=)$/).test(operator) && operator !== '' && operator !== null) {
        this.text = "polje 'operator' vsebuje nedovoljen znak";
        this.types = 'Napaka';
        this.ShowNoti = true;
      }
    },
  }
}
</script>
<template>
  <!-- VNOS JADRALNIH POGOJEV -->
  <div class="form-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-plane"></i>
      </div>
      <div class="section-title">
        <h3>Pogoji za jadralno letenje</h3>
        <p>pogoji, ki bodo uporabljeni pri vnosu v dnevi razpored letenja</p>
        <span>
	                    	Navodila za vnos nastavitev:
	                    	<ul>
	                    		<li>
	                    			<strong>Polje v bazi</strong>
	                    			<ul>
		                    			<li> vrednost mora biti enaka kot je ime polja v tabeli. Če gre za splošno nastavitev, kot je npr. primerjanje časa, pustimo polje prazno.</li>
		                    		</ul>
	                    		</li>
	                    		<li>
	                    			<strong>Metoda za izvedbo</strong>
	                    			<ul>
		                    			<li> vrednost mora biti enaka (tudi male/velike črke) z metodo, ki je uporabljena v API-ju. npr. stVzletov, st_vzletov..<br/>
		                    			Če metoda ne obstaja v API-ju pogoj ne bo pregledan.</li>
		                    		</ul>
	                    		</li>
	                    		<li>
	                    			<strong>Operator</strong>
	                    			<ul>
		                    			<li> veljavni operatorji so <strong></strong>, <strong><</strong>, <strong><=</strong>, <strong>>=</strong>, <strong>==</strong></li>
		                    		</ul>
	                    		</li>
	                    		<li>
	                    			<strong>Nastavitev(vrednost)</strong>
	                    			<ul>
		                    			<li> Če vnašamo čas za preverjanje, ki se upošteva v SQL queryu je potrebno vnesti v dneh. Za časovnico dveh let torej vnesemo 730 itd.</li>
		                    		</ul>
	                    		</li>
	                    	</ul>
	                    </span>
      </div>
    </div>
    <div class="section-content">
      <div class="form-grid">
        <!-- 	                    <div class="form-group">
                                  <label class="form-label">Čas preverjanja pogojev v dnevih</label>
                                  <input type="number"
                                         v-model="gliding.from"
                                         class="form-input"
                                         :class="{'error': getFieldError('from')}"
                                         step='1'
                                         placeholder="90" />
                                  <div class="error-message" v-if="getFieldError('from')">
                                      {{ getFieldError('from') }}
                                  </div>
                              </div>
                              <div class="form-group">
                                  <label class="form-label">Min št. vzletov</label>
                                  <input type="number"
                                         v-model="gliding.takeoffs"
                                         step="1"
                                         class="form-input"
                                         placeholder="15" />
                              </div>
                              <div class="form-group">
                                  <label class="form-label">Min št. ur letenja</label>
                                  <input type="number"
                                         v-model="gliding.hours"
                                         step="1"
                                         class="form-input"
                                         placeholder="3" />
                              </div>
                              <div class="form-group">
                                  <label class="form-label">Št. letov z instruktorjem</label>
                                  <input type="number"
                                         v-model="gliding.withInstruktor"
                                         step="1"
                                         class="form-input"
                                         placeholder="2" />
                              </div> -->

        <TransitionGroup name="fade">
          <div v-for="(jadro, index) in jadranje" class="form-group" :key="index">
            <div :class="{ hidden: jadro.nastavitev.length > 0 }" class="label-time">Nastavitev jadranja: {{jadro.nastavitev}} - <button class="btn btn-outline-danger rounded btn-sm" @click.prevent="OdstraniNastavitev(index, 'jadralno')"><i  class="far fa-minus fa" ></i></button></div>
            <label :class="{ hidden: jadro.vrednost.length > 0 }" class="label-time p-2" for="potnik-ime-{{index}}">Nastavitev (ime)</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="jadro.nastavitev" required />
            <label :class="{ hidden: (jadro.polje !== null) ? jadro.polje.length > 0 : false }" class="label-time p-2" for="potnik-ime-{{index}}">Polje v tabeli?</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="jadro.polje" required />
            <label :class="{ hidden: (jadro.metoda !== null) ? jadro.metoda.length > 0 : false }" class="label-time p-2" for="potnik-ime-{{index}}">Metoda za izvedbo</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="jadro.metoda" required />
            <label :class="{ hidden: (jadro.operator !== null) ? jadro.operator.length > 0 : false }" class="label-time p-2" for="potnik-ime-{{index}}">Operator</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="jadro.operator" required />
            <label :class="{ hidden: jadro.vrednost.length > 0 }" class="label-time p-2" for="potnik-ime-{{index}}">Nastavitev (vrednost)</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="jadro.vrednost" required />
          </div>
        </TransitionGroup>
        <div class="container p-2">
          <button class="btn btn-outline-success rounded" @click.prevent="DodajNastavitevJadro()">Dodaj nastavitev</button>
        </div>
      </div>
    </div>
    <!-- Form Actions -->
    <div class="form-actions">
      <div class="action-buttons">
        <button type="button"
                class="btn btn-primary"
                @click.prevent="UpdateGliding()"
                :disabled="isSubmitting">
          <i class="fas fa-sync-alt" v-if="!isSubmitting"></i>
          <i class="fas fa-sync-alt fa-spin" v-if="isSubmitting"></i>
          <span v-if="isSubmitting">Posodabljam</span>
          <span v-else>Posodobi vnos</span>
        </button>
      </div>
    </div>
  </div>
  <!-- VNOS MOTORNIH POGOJEV -->
  <div class="form-section">
    <div class="section-header">
      <div class="section-icon">
        <i class="fas fa-plane-departure"></i>
      </div>
      <div class="section-title">
        <h3>Pogoji za motorno letenje</h3>
        <p>pogoji, ki bodo uporabljeni pri vnosu v dnevi razpored letenja</p>
        <span>
	                    	Navodila za vnos nastavitev:
	                    	<ul>
	                    		<li>
	                    			<strong>Polje v bazi</strong>
	                    			<ul>
		                    			<li> vrednost mora biti enaka kot je ime polja v tabeli. Če gre za splošno nastavitev, kot je npr. primerjanje časa, pustimo polje prazno.</li>
		                    		</ul>
	                    		</li>
	                    		<li>
	                    			<strong>Metoda za izvedbo</strong>
	                    			<ul>
		                    			<li> vrednost mora biti enaka (tudi male/velike črke) z metodo, ki je uporabljena v API-ju. npr. stVzletov, st_vzletov..<br/>
		                    			Če metoda ne obstaja v API-ju pogoj ne bo pregledan.</li>
		                    		</ul>
	                    		</li>
	                    		<li>
	                    			<strong>Operator</strong>
	                    			<ul>
		                    			<li> veljavni operatorji so <strong></strong>, <strong><</strong>, <strong><=</strong>, <strong>>=</strong>, <strong>==</strong></li>
		                    		</ul>
	                    		</li>
	                    		<li>
	                    			<strong>Nastavitev(vrednost)</strong>
	                    			<ul>
		                    			<li> Če vnašamo čas za preverjanje, ki se upošteva v SQL queryu je potrebno vnesti v dneh. Za časovnico dveh let torej vnesemo 730 itd.</li>
		                    		</ul>
	                    		</li>
	                    	</ul>
	                    </span>
      </div>
    </div>
    <div class="section-content">
      <div class="form-grid">
        <!-- 	                    <div class="form-group">
                                  <label class="form-label">Čas preverjanja pogojev v dnevih</label>
                                  <input type="number"
                                         v-model="gliding.from"
                                         class="form-input"
                                         :class="{'error': getFieldError('from')}"
                                         step='1'
                                         placeholder="90" />
                                  <div class="error-message" v-if="getFieldError('from')">
                                      {{ getFieldError('from') }}
                                  </div>
                              </div>
                              <div class="form-group">
                                  <label class="form-label">Min št. pristankov</label>
                                  <input type="number"
                                         v-model="gliding.takeoffs"
                                         step="1"
                                         class="form-input"
                                         placeholder="15" />
                              </div> -->
        <TransitionGroup name="fade">
          <div v-for="(motorno, index) in motorna" class="form-group" :key="index">
            <div :class="{ hidden: motorno.nastavitev.length > 0 }" class="label-time">Nastavitev jadranja: {{motorno.nastavitev}} - <button class="btn btn-outline-danger rounded btn-sm" @click.prevent="OdstraniNastavitev(index, 'motorno')"><i  class="far fa-minus fa" ></i></button></div>
            <label :class="{ hidden: motorno.vrednost.length > 0 }" class="label-time p-2" for="potnik-ime-{{index}}">Nastavitev (ime)</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="motorno.nastavitev" required />
            <label :class="{ hidden: (motorno.polje !== null) ? motorno.polje.length > 0 : false }" class="label-time p-2" for="potnik-ime-{{index}}">Polje v bazi?</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="motorno.polje" required />
            <label :class="{ hidden: (motorno.metoda !== null) ? motorno.metoda.length > 0 : false }" class="label-time p-2" for="potnik-ime-{{index}}">Metoda za izvedbo</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="motorno.metoda" required />
            <label :class="{ hidden: (motorno.operator !== null) ? motorno.operator.length > 0 : false }" class="label-time p-2" for="potnik-ime-{{index}}">Operator</label>
            <input class="input border-0 rounded-4 p-2 fs-5" :class="{'required-field': (!(/^(>=|<=|>|<|=)$/).test(motorno.operator) && motorno.operator != null && motorno.operator !== '')}" type="text" id="{{index}}" v-model="motorno.operator" required @change="CheckOperator(motorno.operator)" />
            <label :class="{ hidden: motorno.vrednost.length > 0 }" class="label-time p-2" for="potnik-ime-{{index}}">Nastavitev (vrednost)</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="{{index}}" v-model="motorno.vrednost" required />
          </div>
        </TransitionGroup>
        <div class="container p-2">
          <button class="btn btn-outline-success rounded" @click.prevent="DodajNastavitevMotorno()">Dodaj nastavitev</button>
        </div>
      </div>
    </div>
    <!-- Form Actions -->
    <div class="form-actions">
      <div class="action-buttons">
        <button type="button"
                class="btn btn-primary"
                @click.prevent="UpdateMotor()"
                :disabled="isSubmitting">
          <i class="fas fa-sync-alt" v-if="!isSubmitting"></i>
          <i class="fas fa-sync-alt fa-spin" v-if="isSubmitting"></i>
          <span v-if="isSubmitting">Posodabljam</span>
          <span v-else>Posodobi vnos</span>
        </button>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="BrisiNastavitev()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>